$(function () {
    $('[data-map-simple]').each(function () {
        init(this);
    });

    function init(el) {
        var defaultLatLng = { lat: 41.551029, lng: -8.428204 };
        var map = new google.maps.Map(el, {
            center: defaultLatLng,
            zoom: 10,
            disableDefaultUI: true
        });
        map.setOptions({ draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true });

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
                map.setZoom(15);

                setRadius(map, { lat: position.coords.latitude, lng: position.coords.longitude });
            });
        } else {
            setRadius(map, defaultLatLng);
        }
    }

    function setRadius(map, position) {
        var cityCircle = new google.maps.Circle({
            strokeColor: '#FF0000',
            strokeOpacity: 0.5,
            strokeWeight: 1,
            fillColor: '#FF0000',
            fillOpacity: 0.35,
            map: map,
            center: position,
            radius: 150
        });
    }
});